/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { DividerComponentDisplay } from "cms/components/components/divider/display";
import { DividerComponentEditor } from "cms/components/components/divider/edit";

const DividerComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <DividerComponentDisplay />,
        editComponent: <DividerComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

DividerComponent.displayName = "DividerComponent";
export { DividerComponent };
